import { atom } from "jotai";
import type { ComposerContextType } from "@zapier/agent-system";

/**
 * This atom stores a reference to the composer service API.
 * Components can import this atom and use it to send messages to the chat interface.
 *
 * To register a ComposerService, you should do:
 * ```
 * const setComposerService = useSetAtom(composerServiceAtom);
 *
 * useEffect(() => {
 *   setComposerService({
 *     sendMessage: (message, data) => { ... },
 *     resetChat: () => { ... },
 *     setMessages: (messages) => { ... },
 *     handleSubmit: (event, options) => { ... }
 *   });
 *
 *   return () => setComposerService(null);
 * }, []);
 */
export const composerServiceAtom = atom<ComposerContextType | null>(null);

composerServiceAtom.debugLabel = "composerServiceAtom";
